import {
  Paper,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Avatar,
  Typography,
  Divider,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import dayjs from "utils/dayjs";
import relativeTime from "dayjs/plugin/relativeTime";

dayjs.extend(relativeTime);

export default function RecentUsers({data}) {
  const { t } = useTranslation();
  
  return (
    <Paper sx={{ p: 2, height: 500, overflow: "hidden" }}>
      <Typography variant="body2" color="text.secondary" sx={{height : "30px", fontSize:"20px", marginTop:"5px"}}>
        {t('message.common.subtitle.activity.recentUsers')}
      </Typography>

      <Divider sx={{ mb: 1 }} />

      <List dense>
        {data?.map((u, i) => (
          <ListItem key={i}>
            <ListItemAvatar>
              <Avatar>{u.userName[0]}</Avatar>
            </ListItemAvatar>

            <ListItemText
              primary={u.userName}
              secondary={`· ${ dayjs(u.lastAccessedAt).fromNow()}`}
            />
          </ListItem>
        ))}
      </List>
    </Paper>
  );
}